import { Grid, TextField, Autocomplete, FormControl } from "@mui/material";

import { useGetPhysiciansQuery } from "app/store/transmission/api/transmissionTableApi";
import { getClinicUserFacility } from "utils/currentUser.util";

const PhysiciansInput = ({
  fields,
  onUpdate,
  label = "Physician",
  isCrossFacilityClinicUpload = () => false,
}) => {
  const { data: physicianData = [] } = useGetPhysiciansQuery({
    isPhysicianModal: true,
    active: true,
    ...(isCrossFacilityClinicUpload(fields?.account)
      ? { facility: getClinicUserFacility() }
      : {}),
  });

  const filteredPhysicians = physicianData.filter((physician) =>
    physician.accounts.some((account) => account.includes(fields.account))
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <Autocomplete
            id="physicians"
            disableClearable={false}
            disabled={isCrossFacilityClinicUpload(fields?.account)}
            options={filteredPhysicians}
            value={
              filteredPhysicians?.find(
                ({ userId }) => userId === fields?.physicians?.[0]
              ) || {}
            }
            onChange={(_event, selectedOption) => {
              onUpdate({
                physicians: selectedOption?.userId
                  ? [selectedOption.userId]
                  : [],
              });
            }}
            getOptionLabel={(option) => option?.name || ""}
            isOptionEqualToValue={(option, value) =>
              option?.userId === value?.userId
            }
            noOptionsText="No physicians available under the selected account."
            data-action="physicians-input-select"
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                data-text="physicians-input-label"
              />
            )}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default PhysiciansInput;
